// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9994 0.801758L18.0527 4.79461L17.0007 6.38954V9.4997L20.3352 11.9998H22.002V13.9998H21.002V21.9998H13V17H11V21.9998H3.00195V13.9998H2.00195V11.9998H3.66853L7.00065 9.4999V6.38918L5.94855 4.79491L11.9994 0.801758ZM15.6674 10.9998H8.33407L7.00117 11.9998H17.0012L15.6674 10.9998ZM13.0059 4.99805H11.002V7.00195H13.0059V4.99805Z"}}]};

const CityAncient2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-ancient-2-filled',
    ref,
    icon: element,
  },
));

CityAncient2FilledIcon.displayName = 'CityAncient2FilledIcon';

export default CityAncient2FilledIcon;
